import { render, staticRenderFns } from "./invoiceAndStockComparison.vue?vue&type=template&id=47aa0e89&scoped=true&"
import script from "./invoiceAndStockComparison.vue?vue&type=script&lang=js&"
export * from "./invoiceAndStockComparison.vue?vue&type=script&lang=js&"
import style0 from "./invoiceAndStockComparison.vue?vue&type=style&index=0&id=47aa0e89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa0e89",
  null
  
)

export default component.exports